import { render, staticRenderFns } from "./ContactPricingAgreementCard.vue?vue&type=template&id=25dd9cd6"
import script from "./ContactPricingAgreementCard.vue?vue&type=script&lang=ts"
export * from "./ContactPricingAgreementCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports